import { useOutliersConfigSlice } from 'widgets/outliers/store/config/configSlice';
import { useWidgetWithDockablePanelDimensions } from 'widgets/utils/useWidgetWithDockablePanelDimensions';
import { initialOutliersConfigState } from 'widgets/outliers/store/config/OutliersConfigState';

export function useOutlierWidgetDimensions() {
    const { config } = useOutliersConfigSlice();
    const { showGrid } = config;
    return useWidgetWithDockablePanelDimensions({
        showDockablePanel: !!showGrid,
        initialConfig: initialOutliersConfigState,
    });
}
